import { Store, CurrentUser } from "./store"
import { Api } from "./api"

export const INTERCOM_APP_ID = "gldix7ww"

// Resets on full page reload (module re-init), which is when we need to re-boot.
let intercomBooted = false

export function isIntercomBooted() {
  return intercomBooted
}

export function bootIntercom(user) {
  if (intercomBooted) return

  // NOTE: This is fixed in the tanstack migration since first and last name fields
  // are separate and required in the register route, so there's no need to check
  // if the last name doesnt exist. Not the case right now however!
  const fullName = user.last_name
    ? `${user.first_name} ${user.last_name}`
    : user.first_name

  intercomBooted = true
  window.Intercom?.("boot", {
    api_base: "https://api-iam.intercom.io",
    app_id: INTERCOM_APP_ID,
    name: fullName,
    email: user.email,
  })
}

export function shutdownIntercom() {
  intercomBooted = false
  window.Intercom?.("shutdown")
}

export async function UserLogin(username, password) {
  const api = new Api()
  const resp = await api.accountsLogin(username, password)
  console.log("Logged in", resp)
  if (!resp) return false

  CurrentUser.updateValue((user) => {
    user.username = username
  })

  const user = await api.currentUserRetrieve()
  if (!user) return false
  return true
}

export async function UserRetrieve() {
  const api = new Api()
  console.log("Retrieving currentUser")
  const user = await api.currentUserRetrieve()
  console.log("Retrieved currentUser", user)
  if (!user) return false
  bootIntercom(user)
  return true
}

export async function UserIsLoggedIn() {
  const loggedIn = await UserRetrieve()
  console.log("UserIsLoggedIn", "loggedIn=", loggedIn)
  return loggedIn
}

export async function UserLogout() {
  shutdownIntercom()

  // TODO: This is probably not a great way to manage state
  Store("currentUser").setValue({})
  Store("datasets").setValue({})
  Store("schemas").setValue({})
  Store("datasetSchemas").setValue({})
  Store("hashedSchemas").setValue({})

  const api = new Api()
  await api.accountsLogout()
}

export async function UserRegister(email, password, fullName) {
  const api = new Api()
  const resp = await api.accountsRegister(email, password, fullName)
  console.log("Registered new user", resp)
  if (!resp) return false
  return true
}
